module.exports = __webpack_public_path__ + "static/UnclickSpecialYellow-651374090cde0383fe440c9ee6f10083.png";